import type { GameModuleOptions } from '@game/types'
import { useRuntimeConfig } from '#imports'

export const useGameConfig = (): GameModuleOptions => {
    const config = useRuntimeConfig()

    return config.public.game as unknown as GameModuleOptions
}
